var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    fill: "#CBECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_2661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9922 20.4964H7.99502V16.0172C8.0034 14.8318 8.47805 13.6973 9.31635 12.8591C10.1547 12.0209 11.2892 11.5463 12.4748 11.538H16.9545V14.539H19.9431V11.5444H43.9417V14.5454H46.9431V11.5444H51.4228C52.6109 11.5444 53.7504 12.0163 54.5905 12.8563C55.4306 13.6963 55.9026 14.8356 55.9026 16.0236L55.9922 20.4964ZM55.9922 50.4942C55.9922 51.6822 55.5202 52.8215 54.6801 53.6615C53.84 54.5015 52.7005 54.9734 51.5124 54.9734H12.5003C11.3122 54.9734 10.1728 54.5015 9.33272 53.6615C8.4926 52.8215 8.02061 51.6822 8.02061 50.4942V23.4974H56.0178L55.9922 50.4942ZM51.5124 8.49849H47.0327V4.01929H44.0313V8.49849H20.0327V4.01929H17.0377V8.49849H12.558C10.5687 8.50188 8.66193 9.29396 7.25589 10.701C5.84985 12.1081 5.05931 14.0153 5.05762 16.0043V50.5006C5.05931 52.4891 5.85005 54.3956 7.25628 55.8017C8.6625 57.2077 10.5693 57.9984 12.558 58.0001H51.4996C53.4878 57.9967 55.3936 57.2055 56.7995 55.7998C58.2053 54.3941 58.9966 52.4886 59 50.5006V15.9979C58.9966 14.01 58.2053 12.1045 56.7995 10.6988C55.3936 9.29307 53.4878 8.50187 51.4996 8.49849H51.5124Z",
    fill: "#0072CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_2661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvents);
export default __webpack_public_path__ + "static/media/icon-events.f81fc2a27837d1de2530353cc3c2aa6f.svg";
export { ForwardRef as ReactComponent };